export default{
  FORMATION_GROUPCARDS:'FORMATION',
  FORMATION_INDIVIDUAL_DETAILS: "INDIVIDUAL_DETAILS",
  FORMATION_INDIVIDUAL_ADGM: "INDIVIDUAL_ADGM",
  FORMATION_COMPANY_DETAILS: "COMPANY_DETAILS",
  FORMATION_COMPANY_ADGM: "COMPANY_ADGM",
  FORMATION_COMPANY_CONFIRM: "COMPANY_CONFIRM",
}